import React, { useState, useEffect } from 'react';
import { obtenerMesas, liberarMesa } from '../../services/mesasServicio'; 
import { toast } from 'react-toastify';
import CatalogoMesas from './CatalogoMesas';

const PedidosMesa = () => {
    const [mesas, setMesas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mesaActiva, setMesaActiva] = useState(null);

    useEffect(() => {
        cargarMesas();
        const intervalo = setInterval(() => {
            if (!mesaActiva) cargarMesas();
        }, 30000);
        return () => clearInterval(intervalo);
    }, [mesaActiva]);

    const cargarMesas = async () => {
        try {
            const data = await obtenerMesas();
            setMesas(Array.isArray(data) ? data : []);
        } catch (error) {
            toast.error("Error al cargar mesas.");
        } finally {
            setLoading(false);
        }
    };

    const volverYRefrescar = () => {
        setMesaActiva(null);
        cargarMesas();
    };

    const handleCancelarMesa = async (mesa, e) => {
        e.stopPropagation();
        if (!window.confirm(`¿Estás seguro de liberar la ${mesa.nombre}?`)) return;
        try {
            await liberarMesa(mesa.id);
            toast.success(`La ${mesa.nombre} ha sido liberada.`);
            cargarMesas();
        } catch (error) {
            toast.error("Error al intentar liberar la mesa.");
        }
    };

    if (mesaActiva) {
        return <CatalogoMesas key={mesaActiva.id} mesa={mesaActiva} onVolver={volverYRefrescar} />;
    }

    return (
        <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', paddingBottom: '80px' }}>
            {/* 🚩 HEADER SHOPIFY (mismo estilo que Pedidos) */}
            <div className="bg-white border-bottom shadow-sm px-4 py-3 sticky-top" style={{ zIndex: 100 }}>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                        <h2 className="h5 fw-bold mb-0 text-dark">
                            <i className="fas fa-th-large text-dark mr-2"></i> Gestor de Pedidos
                        </h2>
                        <small className="text-muted">{mesas.length} mesa{mesas.length !== 1 ? 's' : ''}</small>
                    </div>
                    <button className="btn btn-dark btn-sm rounded-pill px-4 fw-bold shadow-sm" onClick={cargarMesas} disabled={loading} style={{ fontSize: '0.85rem' }}>
                        {loading ? <><i className="fas fa-spinner fa-spin mr-1"></i> Actualizando...</> : <><i className="fas fa-sync-alt mr-1"></i> Actualizar</>}
                    </button>
                </div>
            </div>
            <div className="container mt-4">
                {/* Leyenda */}
                <div className="d-flex justify-content-center mb-4" style={{ gap: '10px' }}>
                    <div className="small"><i className="fas fa-circle text-success"></i> Libre</div>
                    <div className="small"><i className="fas fa-circle text-danger"></i> Ocupada</div>
                    <div className="small"><i className="fas fa-circle text-warning"></i> Cuenta</div>
                </div>

                {loading ? (
                    <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <div className="row justify-content-center">
                        {mesas.map((mesa) => {
                            const esLibre = mesa.estado === 'LIBRE';
                            const esPorCobrar = mesa.estado === 'PENDIENTE' || Number(mesa.estado_id) === 7;

                            // Colores Estilo Fudo
                            let bgColor = '#ffffff'; 
                            let iconColor = '#6c757d';
                            let borderColor = '#dee2e6';
                            let statusIcon = 'fa-chair';

                            if (!esLibre) {
                                bgColor = '#ff4d4d'; // Rojo vibrante
                                iconColor = '#fff';
                                borderColor = '#ff4d4d';
                                statusIcon = 'fa-users';
                            }
                            if (esPorCobrar) {
                                bgColor = '#ffc107'; // Amarillo Fudo
                                iconColor = '#000';
                                borderColor = '#ffc107';
                                statusIcon = 'fa-file-invoice-dollar';
                            }
                            if (esLibre) {
                                bgColor = '#2ecc71'; // Verde Fudo
                                iconColor = '#fff';
                                borderColor = '#2ecc71';
                            }

                            return (
                                <div key={mesa.id} className="col-4 col-sm-3 col-md-2 mb-4 d-flex justify-content-center">
                                    <div style={{ position: 'relative', width: '100px' }}>
                                        
                                        {/* LA MESA REDONDA */}
                                        <button
                                            className="btn shadow-sm mesa-circular"
                                            onClick={() => setMesaActiva(mesa)}
                                            style={{
                                                backgroundColor: bgColor,
                                                border: `3px solid ${borderColor}`,
                                                borderRadius: '50%', // Círculo perfecto
                                                width: '90px',
                                                height: '90px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'transform 0.2s, box-shadow 0.2s',
                                                padding: 0,
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <i className={`fas ${statusIcon}`} style={{ fontSize: '20px', color: iconColor }}></i>
                                            <span style={{ 
                                                fontSize: '14px', 
                                                fontWeight: 'bold', 
                                                color: iconColor,
                                                lineHeight: '1.1',
                                                marginTop: '2px'
                                            }}>
                                                {mesa.nombre.replace('Mesa ', '')} {/* Solo el número para que quepa bien */}
                                            </span>
                                        </button>

                                        {/* Botón X de liberación rápida */}
                                        {!esLibre && (
                                            <div 
                                                onClick={(e) => handleCancelarMesa(mesa, e)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-2px',
                                                    right: '-2px',
                                                    backgroundColor: '#343a40',
                                                    color: 'white',
                                                    borderRadius: '50%',
                                                    width: '24px',
                                                    height: '24px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '10px',
                                                    cursor: 'pointer',
                                                    zIndex: 10,
                                                    border: '2px solid white'
                                                }}
                                            >
                                                <i className="fas fa-times"></i>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* CSS Extra para efectos visuales */}
            <style>{`
                .mesa-circular:hover {
                    transform: scale(1.1);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.2) !important;
                }
                .mesa-circular:active {
                    transform: scale(0.95);
                }
            `}</style>
        </div>
    );
};

export default PedidosMesa;